import React, { Component } from 'react';
import { List, InputItem } from 'antd-mobile';
import { $t } from '@/utils/utils';
class DPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      hasError: true,
      errorMsg: $t('plzPwd'),
      visible: false,
      isFirst: false,
    }
  };

  _onBlur = () => {
    this.setState({ isFirst: true, });
  }
  _onChange = (val) => {
    this.setState({ value: val, });
    setTimeout(()=>{
      this.emitVal();
      this.checkVal();
    })
  }
  emitVal = () => {
    this.props.onChange(this.state);
  }

  checkVal = () => {
    this.setState({ isFirst: true, });
    const val = this.state.value;
    let _v = val.replace(/\s/g, '');
    let m = this.props.rePassword ? $t('comPwd') : $t('pwd');

    if (!_v.length) {
      this.setState({
        hasError: true,
        errorMsg: `${ $t('plzInput') } ${ m }!`,
      })
    } else if (_v.length < 4){
      this.setState({
        hasError: true,
        errorMsg: `${ m } ${ $t('less4') }`,
      })
    } else {
      if( this.props.rePassword && this.props.passwordVal !== val ) {
        this.setState({
          hasError: true,
          errorMsg: $t('notMatch2Pwd'),
        })
      } else {
        this.setState({ hasError: false, errorMsg: '', });
      }
    }

    this.setState({ isFirst: true, });
    setTimeout(()=>{
      // this.setState({ value: val, });
      this.props.onChange(this.state);
    })
    this.emitVal();
  }
  _onFocus = () => {
    this.props.onFocus();
  }
  onVisClick = () => {
    this.setState({ visible: !this.state.visible, });
  }

  componentDidMount() {
    this.props.onRef && this.props.onRef(this);
  }

  render() {
    let dError;
    const Eye = <img className='eye-icon' src={ window.$localCdnLink + '/svg/eye.svg' } alt='MIB' onClick={this.onVisClick} />;
    const EyeHide = <img className='eye-icon' src={ window.$localCdnLink + '/svg/eye_hide.svg' } alt='MIB' onClick={this.onVisClick} />;
    if ((this.state.isFirst || this.props.first) && this.state.hasError) {
      dError = <span className='hasError-box'>{ this.state.errorMsg }</span>
    }
    let extra = this.state.visible ? Eye : EyeHide;
    let type = this.state.visible ? 'text' : 'password';

    return <List renderHeader={() => this.props.label }>
      <InputItem
        type={type}
        error={this.state.hasError}
        onChange={this._onChange}
        onBlur={() => this._onBlur()}
        value={this.state.value}
        extra={extra}
        onFocus={() => this._onFocus()}
      >
      </InputItem>
      { dError }
    </List>
  }
}

export default DPassword;
